import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { FileUploadService } from './file-upload.service';

@Component({
    selector: 'app-file-upload',
    templateUrl: 'file-upload.component.html'
})

export class FileUploadComponent implements OnInit {
    uploadingFile: boolean;
    @Output() onFileUploaded = new EventEmitter<{}>();
    @Output() onUploading = new EventEmitter<{}>();
    constructor(private fileUploadService: FileUploadService) { }

    ngOnInit() {
        this.uploadingFile = false;
    }

    fileChange(event) {
        const fileList: FileList = event.target.files;
        if (fileList.length > 0) {
            this.uploadingFile = true;
            this.onUploading.emit(this.uploadingFile);
            const file: File = fileList[0];
            const formData: FormData = new FormData();
            formData.append('file', file, file.name);
            this.fileUploadService.uploadFile(file).then(
                function(filename: any){
                    this.onFileUploaded.emit(filename);
                    this.uploadingFile = false;
                    this.onUploading.emit(this.uploadingFile);
                }.bind(this),
                function(){
                    this.uploadingFile = false;
                    this.onUploading.emit(this.uploadingFile);
                }.bind(this)
            );
        }
    }
}




// WEBPACK FOOTER //
// ./src/app/shared/file-upload/file-upload.component.ts